import { FC } from 'react';
import { ButtonSelect, InputSlider } from './';
import { weightItems } from '../constants';
import { Weights } from '../enums';
import strings from '../language/Swedish';
import styled from 'styled-components';
import tw from 'twin.macro';

const UnitContainer = styled.span`
  ${tw`text-slate-500 pr-2 text-sm w-auto`}
`;

interface Props {
  inputMin: number;
  inputMax: number;
  weightValue: Weights;
  refValue?: number;
  keyWeightEl: string;
  unit?: string;
  keyRefEl?: string;
  handleRefValueChange: (keyEl: string, value: number) => void;
  handleWeightValueChange: (keyEl: string, value: Weights) => void;
}

const AdvancedWeightRefContent: FC<Props> = ({
  refValue = 0,
  keyWeightEl,
  keyRefEl,
  weightValue,
  inputMax,
  unit,
  inputMin,
  handleRefValueChange,
  handleWeightValueChange,
}) => {
  const handleWeightChange = (value: string) => {
    const weightValue = parseInt(value, 10);

    handleWeightValueChange(keyWeightEl, weightValue);
  };

  const handleRefChange = (value: [number]) => {
    if (keyRefEl) {
      handleRefValueChange(keyRefEl, value[0]);

      if (keyRefEl) {
        handleRefValueChange(keyRefEl, value[0]);
      }
      if (keyWeightEl && value[0] && weightValue === Weights.none)
        handleWeightValueChange(keyWeightEl, Weights.medium);
    }
  };

  return (
    <InputSlider
      value={[refValue]}
      min={inputMin}
      max={inputMax}
      handleValueChange={handleRefChange}>
      {unit && <UnitContainer>{unit}</UnitContainer>}
      <ButtonSelect
        label={strings.filter.relevanse}
        ariaLabel={strings.filter.relevanse}
        items={weightItems}
        value={weightValue}
        handleValueChange={handleWeightChange}
      />
    </InputSlider>
  );
};

export default AdvancedWeightRefContent;
